import CustomTable from "../CustomTable";
import routes from "../../../engine/routes";
import React from "react";
import {
  daysJsFormat,
  formatCurrency,
  languagesList,
  renderStatusPrestation,
  renderStatusTag,
  renderTypePrestation,
  renderUserName,
  roles,
  subStatusPrestations,
} from "../../../utils/constants";
import { userHasLevel } from "../../../engine/AuthRoute";
import dayjs from "../../../utils/dayjs";

export const RenderCostsTable = ({ cost }) => {
  const pagination = {
    hideOnSinglePage: true,
    position: ["topRight"],
    defaultPageSize: 10,
    pageSizeOptions: [10, 20, 50, 100],
    showSizeChanger: true,
  };

  const uniqueInterprete = new Set();

  let newArrCosts = cost.costsMultiple.map(obj => {
    let pres = cost.prestations.find(e => e._id === obj?.prestationId);

    uniqueInterprete.add(pres.interprete._id);

    return {
      ...obj,
      prestation: pres,
    };
  });

  let arrayInterprete = [...uniqueInterprete];

  const columns = multiple => {
    return [
      {
        title: "N Prestation",
        dataIndex: "reference",
        key: "reference",
        render: (r, i) => i.prestation.reference,
        sorter: (a, b) => {
          return a?.prestation.reference - b?.prestation.reference;
        },
      },
      {
        title: "Interprete",
        dataIndex: "prestation",
        key: "prestation",
        sorter: (a, b) => {
          const nameA = renderUserName(a.prestation.interprete);
          const nameB = renderUserName(b.prestation.interprete);

          return nameA.localeCompare(nameB);
        },
        render: (prestation, record) => {
          return <b>{renderUserName(prestation.interprete)}</b>;
        },
        filters: arrayInterprete
          .filter(e => e !== "" && e !== null)
          .map(o => {
            let name = cost.prestations.find(e => e.interprete._id === o);

            return { text: renderUserName(name.interprete), value: o };
          }),
        onFilter: (value, record) => {
          return record.prestation.interprete._id === value;
        },
      },
      {
        title: "Type de prestation",
        dataIndex: "type_pres",
        key: "type_pres",
        render: (r, i) => renderTypePrestation(i.prestation.intervention.type),
        sorter: (a, b) => {
          return a.prestation.intervention.type.localeCompare(
            b.prestation.intervention.type,
          );
        },
      },
      {
        title: "Langue",
        dataIndex: "lang",
        key: "lang",
        render: (r, i) =>
          i.prestation.language.map(
            p => languagesList.find(e => e.value === p).label,
          ),
        sorter: (a, b) => {
          let stringA = a.prestation.language.map(e => e).join(" ");
          let stringB = b.prestation.language.map(e => e).join(" ");

          return stringA.localeCompare(stringB);
        },
      },
      {
        title: "Montant",
        dataIndex: "amount",
        key: "amount",
        render: (r, i) => formatCurrency(i.costParams.total),
        sorter: (a, b) => {
          return a.costParams.total - b.costParams.total;
        },
      },
      {
        title: "Frais de déplacement",
        dataIndex: "amount",
        key: "amount",
        render: (r, i) =>
          formatCurrency(i.cost.find(e => e.type === "travel")?.amount || 0),
        sorter: (a, b) => {
          const amountA = a.cost.find(e => e.type === "travel")?.amount || 0;
          const amountB = b.cost.find(e => e.type === "travel")?.amount || 0;
          return amountA - amountB;
        },
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (r, i) => {
          return renderStatusPrestation(i.prestation, { showControls: false });
        },
      },
      /* {
        title: "Catégorie",
        dataIndex: "type",
        key: "type",
        render: (type, item) => {
          const categories = item?.category?.join(", ");

          return (
            <span>
              {type && `${type} `}
              {categories}
            </span>
          );
        },
        filters: arrayCategory
          .filter(e => e !== "" && e !== null)
          .map(o => {
            return { text: o, value: o };
          }),
        onFilter: (value, record) => {
          return record.type === value || record?.category?.includes(value);
        },
      },*/
    ];
  };

  return (
    <CustomTable
      hasPagination={false}
      key={Math.random()}
      onRowLink={record =>
        routes.prestations(record.prestation._id).detail.path
      }
      dataSource={newArrCosts.sort((a, b) => a.reference - b.reference)}
      columns={columns()}
      rowKey={record => record.prestation._id}
    />
  );
};
